import React, { useState ,useEffect } from "react";
import axios from 'axios'
import toast from "react-hot-toast";
import { FaSearch,FaUserCheck} from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import socket from "../socket";

function DealerWithdrawal({token}) {
     const [searchTerm, setSearchTerm] = useState('');
        const[list,setList] = useState([]);
        const [showForm, setShowForm] = useState(false);
    const [showVerifyModal, setShowVerifyModal] = useState(false);
    const [selectedDriver, setSelectedDriver] = useState(null);


    useEffect(() => {
  const handleWithdrawal = (data) => {
       fetchDealerWithdrawal();
    toast.success(data.title);
  };

  socket.on("driver-withdrawal", handleWithdrawal);

  return () => {
    socket.off("driver-withdrawal", handleWithdrawal);
    socket.off("connect");
  };
}, []);

 const fetchDealerWithdrawal = async () => {
  try {
    const res = await axios.get(`https://api.krimotion.in/fetch-dealer-withdrawal`,
       {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
    )
    const result = res.data;
 
    setList(result);
  } catch (error) {
    console.log(error);
  }
};

   useEffect(() => {
    fetchDealerWithdrawal();

  }, []);  
   

  
  const handleVerify = async () => {

  try {
    const res = await axios.put(
      `https://api.krimotion.in/verify-dealer-withdrawal/${selectedDriver.id}`,
      {
        dealer_id:selectedDriver.dealer_id,
        pay_status: "Success",
        paid_on: new Date().toISOString().slice(0, 19).replace("T", " "),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  
    toast.success("Withdrawal verified successfully.");
   setShowVerifyModal(false);
    setSelectedDriver(null);
    fetchDealerWithdrawal();
  } catch (err) {
    console.error(err);
    toast.error("Failed to process withdrawal.");
  }
};

       const filteredData = Array.isArray(list)
    ? list.filter(itm =>
      Object.values(itm).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
    : [];


    const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; 
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};
  return (
   <>
   
     <div className="container py-4">
   
            <div className="border-0  mb-3 px-2 py-2  ">
                            
                            <div className="d-flex flex-column gap-2">
           
             {/* TOP ROW: Title + Search */}
             <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
           
               <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
                 Dealer Withdrawal History
               </h4>
           
               <div style={{ flex: 1, maxWidth: "250px" }}>
                 <div
                   className="d-flex align-items-center rounded-pill overflow-hidden"
                   style={{
                     border: "1px solid var(--green)",
                     height: "34px",
                     paddingLeft: "8px",
                     paddingRight: "8px",
                     backgroundColor: "white"
                   }}
                 >
                   <FaSearch style={{ color: "var(--green)", fontSize: "14px" }} />
           
                   <input
                     type="text"
                     className="form-control border-0 shadow-none"
                     placeholder="Search..."
                     value={searchTerm}
                     onChange={(e) => setSearchTerm(e.target.value)}
                     style={{
                       fontSize: "14px",
                       height: "32px",
                       marginLeft: "6px"
                     }}
                   />
                 </div>
               </div>
           
             </div>
           
           
           
           </div>
           
           
                            </div>
   
          {/* {!showForm && (
                                      <>
                                      
                                  <div className="card shadow-lg border-0 rounded-4 mt-4 overflow-hidden " style={{ background: '#f4f6f9'}}>
                              
                                    <div className="card-body p-3">
                                             <div className="table-responsive">
                                   <table className="table table-hover align-middle mb-0 text-center">
                                     <thead  >
                                       <tr>
                                         <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Name</th>
                                    
                                           <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Enquiry ID </th> 
                                         <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Enquiry For </th> 
                                               <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Amount </th> 
                    
                                  <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Pay Status </th>
                                  <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Request Date </th>   
                                  <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Approve Date</th>                           
        
                                          <th className=" text-center text-white" style={{backgroundColor:'var(--green)'}}>Action</th>
                                       </tr>
                                     </thead>
                             
                                     <tbody>
                                       {filteredData.length > 0 ? (
                                         filteredData.map((dealer, index) => (
                                           <tr key={index}>
                                   
                                             <td>{dealer.d_name}</td>
                                             <td>{dealer.uap_id}</td>
                                                <td>{dealer.uap_type}</td>
                                                <td>
                                                   ₹
       {(
         Number(dealer?.amount || 0) -
         Number(dealer?.platform_fee || 0)
       ).toFixed(2)}
                                                   </td>
                                   <td>
     <span
       className={`status-badge ${
         dealer.pay_status === "Pending"
           ? "status-warning"
           : "status-success"
       }`}
     >
       {dealer.pay_status}
     </span>
   </td>
   
   
                                        <td>{formatDate(dealer.d_withdraw) } </td>
                                    <td>{formatDate(dealer.paid_on || '')} </td>
        <td>
     {dealer.pay_status === "Pending" ? (
       <button
         className="btn-action btn-warning-custom"
         onClick={() => {
           setSelectedDriver(dealer);
           setShowVerifyModal(true);
         }}
       >
      
         Verify
       </button>
     ) : (
       <button className="btn-action btn-success-custom" disabled>
      
         Verified
       </button>
     )}
   </td>
                                   </tr>
                                         ))
                                       ) : (
                                         <tr>
                                           <td colSpan="8" className="text-center py-4">
                                             No List Found
                                           </td>
                                         </tr>
                                       )}
                                     </tbody>
                         
                                   </table>
                                 </div>
                                    </div> 
                             

                               </div>
                             
                                 </>
                                      )} */}


                                      {!showForm && (
  <div className="container-fluid mt-4">
    <div className="row g-4">

      {filteredData.length > 0 ? (
        filteredData.map((dealer, index) => (

          <div className="col-xl-4 col-lg-6 col-md-6" key={index}>

            <div className="inventory-card d-flex flex-column h-100">

              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-3">

                <div>
                  <h5 className="inventory-title mb-1">
                    {dealer.d_name}
                  </h5>

                  <span className="badge bg-primary">
                    {dealer.uap_type}
                  </span>
                </div>

                <span
                  className={`status-badge ${
                    dealer.pay_status === "Pending"
                      ? "status-warning"
                      : "status-success"
                  }`}
                >
                  {dealer.pay_status}
                </span>

              </div>

              {/* Details */}

              <div className="inventory-row">
                <span className="inventory-label">
                  Enquiry ID
                </span>

                <span>{dealer.uap_id}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Amount
                </span>

                <span className="fw-bold text-success">
                  ₹
                  {(
                    Number(dealer?.amount || 0) -
                    Number(dealer?.platform_fee || 0)
                  ).toFixed(2)}
                </span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Request Date
                </span>

                <span>
                  {formatDate(dealer.d_withdraw)}
                </span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Approve Date
                </span>

                <span>
                  {formatDate(dealer.paid_on || "")}
                </span>
              </div>

              {/* Bottom */}

              <div className="mt-auto pt-3">

                {dealer.pay_status === "Pending" ? (

                  <button
                    className="btn-action btn-warning-custom w-100"
                    onClick={() => {
                      setSelectedDriver(dealer);
                      setShowVerifyModal(true);
                    }}
                  >
                    Verify
                  </button>

                ) : (

                  <button
                    className="btn-action btn-success-custom w-100"
                    disabled
                  >
                    Verified
                  </button>

                )}

              </div>

            </div>

          </div>

        ))
      ) : (

        <div className="col-12">

          <div className="text-center py-5">
            No List Found
          </div>

        </div>

      )}

    </div>
  </div>
)}


                                             {showVerifyModal && (
     <div
       className="modal d-block"
       style={{
         background: "rgba(0,0,0,.55)",
         backdropFilter: "blur(5px)",
         zIndex: 9999,
       }}
     >
       <div className="modal-dialog modal-dialog-centered">
         <div
           className="modal-content border-0 shadow-lg"
           style={{ borderRadius: "18px" }}
         >
         
           <div
             className="position-relative text-center py-4"
             style={{
               background: "linear-gradient(135deg,#198754,#20c997)",
             }}
           >
             <button
               className="btn btn-light btn-sm position-absolute"
               style={{
                 right: 15,
                 top: 15,
                 borderRadius: "50%",
                 width: 35,
                 height: 35,
               }}
               onClick={() => setShowVerifyModal(false)}
             >
               ✕
             </button>
   
             <div
               className="mx-auto d-flex align-items-center justify-content-center"
               style={{
                 width: 70,
                 height: 70,
                 borderRadius: "50%",
                 background: "rgba(255,255,255,.2)",
               }}
             >
               
   
               <TiTick  style={{ fontSize: 35, color: "#fff" }}/>
             </div>
   
             <h4 className="text-white fw-bold mt-3 mb-0">
               Verify Withdrawal
             </h4>
           </div>
   
     
           <div className="p-4 text-center">
             <h5 className="fw-bold">
               {selectedDriver?.cust_name}
             </h5>
   
             <p className="text-muted mb-4">
               Are you sure you want to verify this withdrawal?
             </p>
   
             <div className="bg-light rounded-3 p-3 text-start">
               <div className="d-flex justify-content-between">
                 <span>Dealer</span>
                 <strong>{selectedDriver?.d_name}</strong>
               </div>
   
            <div className="d-flex justify-content-between mt-2">
     <span>Amount</span>
     <strong>
       ₹
       {(
         Number(selectedDriver?.amount || 0) -
         Number(selectedDriver?.platform_fee || 0)
       ).toFixed(2)}
     </strong>
   </div>
               <div className="d-flex justify-content-between mt-2">
                 <span>Payment Status</span>
   
                 <span className="badge bg-warning text-dark">
                   {selectedDriver?.pay_status}
                 </span>
               </div>
             </div>
           </div>
   
    
           <div className="px-4 pb-4 d-flex gap-3">
             <button
               className="btn btn-outline-secondary w-50"
               onClick={() => setShowVerifyModal(false)}
             >
               Cancel
             </button>
   
             <button
               className="btn btn-success w-50"
               onClick={handleVerify}
             >
               <i className="bi bi-check-circle me-2"></i>
               Verify Payment
             </button>
           </div>
         </div>
       </div>
     </div>
   )}
   
       </div>
   </>
  )
}

export default DealerWithdrawal
